import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ApiChannel } from 'core/constants';

import { ModelBase } from 'store/model-base';
import { buildHeaders, XmStore } from 'core/services';
import { VideoResolutionInfo } from './models';
import { StoreAction } from 'store/actions';
import { RequestStatus } from 'store/request-status/models';

@Injectable()
export class VideoResolutionApi {
    public static getVideoResolution(_xmStore: XmStore, http: HttpClient, params: ApiParams): Observable<VideoResolutionInfo> {
        const lineId: string = params.lineId;

        return http.get(`/lines/${params.lineId}/features/videoresolution`, {
            headers: buildHeaders({ apiChannel: ApiChannel.GATEWAY })
        }).pipe(
            map((response: ApiResponse) => VideoResolutionInfo.create<VideoResolutionInfo>({ ...response, lineId }))
        );
    }

    public static postVideoResolution(_xmStore: XmStore, http: HttpClient, params: ApiParams): Observable<RequestStatus> {
        return http.post(`/lines/${params.lineId}/features/videoresolution`, params.payload, {
            headers: buildHeaders({ apiChannel: ApiChannel.GATEWAY })
        }).pipe(
            map((response: ApiResponse) => RequestStatus.create<RequestStatus>(response))
        );
    }
}

ModelBase.fetchMapping[StoreAction.GET_VIDEO_RESOLUTION] = VideoResolutionApi.getVideoResolution;
ModelBase.persistMapping[StoreAction.POST_VIDEO_RESOLUTION] = VideoResolutionApi.postVideoResolution;
